import { map, shareReplay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { forkJoin } from 'rxjs';
import { MediaType } from '../gallery/media-type.enum';
import { MediaFile } from '../gallery/media-file.model';

@Injectable({ providedIn: 'root' })
export class ThirdPartyMediaService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  getMedia(airlineIds: number[]) {

    const photosRequest = [
      ...airlineIds.map(id => this.apiService.get(`${this.path}/v2/airlines/${id}/photos`)),
      ...airlineIds.map(id => this.apiService.get(`${this.path}/v2/airlines/${id}/infographics`)),
      ...airlineIds.map(id => this.apiService.get(`${this.path}/v2/airlines/${id}/marketing_graphics`)),
    ];
    const videosRequest = airlineIds.map(id => this.apiService.get(`${this.path}/v2/airlines/${id}/videos`));
    const toursRequest = airlineIds.map(id => this.apiService.get(`${this.path}/v2/airlines/${id}/tours`));

    return forkJoin([forkJoin(photosRequest), forkJoin(videosRequest), forkJoin(toursRequest)]).pipe(
      shareReplay(1),
      map((response: any) => ({
        photos: response[0]?.flat().filter((item: MediaFile) => item.media_type === MediaType.PHOTO),
        infographics: response[0]?.flat().filter((item: MediaFile) => item.media_type === MediaType.INFOGRAPHIC),
        marketing_graphics: response[0]?.flat().filter((item: MediaFile) => item.media_type === MediaType.MARKETING_GRAPHIC),
        videos: response[1].flat(),
        tours: response[2].flat(),
      })),
    );
  }
}
